export const REQUEST_SCHEDULE_DATA = "REQUEST_SCHEDULE_DATA";
export const RECEIVE_SCHEDULE_DATA = "RECEIVE_SCHEDULE_DATA";
export const NO_RESULTS_SCHEDULE_DATA = 'NO_RESULTS_SCHEDULE_DATA';
export const RESET_NO_RESULTS_SCHEDULE_DATA = 'RESET_NO_RESULTS_SCHEDULE_DATA';
export const REQUESTED_SCHEDULE_DATA = 'REQUESTED_SCHEDULE_DATA';
export const ERROR_RETRIEVING_SCHEDULE_DATA = 'ERROR_RETRIEVING_SCHEDULE_DATA';

export const requestScheduleData = (payload) => ({
  type: REQUEST_SCHEDULE_DATA,
  payload
});

export const receiveScheduleData = payload => ({type: RECEIVE_SCHEDULE_DATA, payload: payload});

export const noResultsScheduleData = payload => ({type: NO_RESULTS_SCHEDULE_DATA, payload: payload});

export const errorRetrievingSchedulesData = error => ({type: ERROR_RETRIEVING_SCHEDULE_DATA, payload: error});

export const resetNoResultsScheduleData = () => ({type: RESET_NO_RESULTS_SCHEDULE_DATA});

export const setRequestedScheduleDataFlag = ()  => ({type: REQUESTED_SCHEDULE_DATA});



// WEBPACK FOOTER //
// ./src/actions/schedulesDataActions.js